import { Amplify } from 'aws-amplify';
import outputs from '../../amplify_outputs.json';

export function configureAmplify() {
  Amplify.configure(outputs);
  console.log('Amplify configured successfully with User Pool:', outputs.auth.user_pool_id);
}
